module.exports = __webpack_public_path__ + "static/media/logo.33e74675.png";